import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";
import Sequence from "slotworks/utils/contracts/sequence";
import Logger from "slotworks/utils/logger";

export function parallel<T>(methods: Array<() => Contract<any>>): Contract<T> {
    Logger.info("Deprecated race-utils function being used. Use new Parallel() instead");
    return new Parallel(methods);
}

export function sequence<T>(methods: Array<() => Contract<any>>): Contract<T> {
    Logger.info("Deprecated race-utils function being used. Use new Sequence() instead");
    return new Sequence(methods);
}

export function timesSequence<T>(count: number, method: (index: number) => Contract<any>): Contract<T> {
    return new Sequence(generateFunctionArray(count, method));
}

export function timesParallel<T>(count: number, method: (index: number) => Contract<any>): Contract<T> {
    return new Parallel(generateFunctionArray(count, method));
}

function generateFunctionArray(count: number, method: (index: number) => Contract<any>): Array<() => Contract<any>> {
    const methods = [];

    for (let i = 0; i < count; i++) {
        methods.push(() => method(i));
    }

    return methods;
}

export function eachSeries<T, U>(collection: U[], operation: (item: U) => Contract<T>): Contract<T> {
    return new Sequence(collection.map((item) => () => operation(item)));
}

export function each<T, U>(collection: U[], operation: (item: U) => Contract<T>): Contract<T> {
    Logger.warn("This function has been repurposed, it used to do `return new Parallel(contracts.map((contract) => () => contract));`");
    return new Parallel(collection.map((item) => () => operation(item)));
}

export function waterfall<T>(methods: Array<(input: T) => Contract<T>>, input: T): Contract<T> {
    return new Contract<T>((resolve) => {
        const next = (result: T) => {
            if (!methods.length) {
                resolve(result);
                return;
            }

            const method = methods.shift();
            method(result).then(next);
        };

        next(input);
    });
}
